// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6313) return "static/chunks/6313.030f68a455459397.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"5075":"d8d98ee91eb229c4","5875":"4f8e0a10d0141efb"}[chunkId] + ".js";
};